import {
	FIRST_PARTY_CCP_PRODUCT_IDS,
	useFireCrossFlowAnalyticsEvents as useFireCrossFlowAnalyticsEventsBase,
} from '@atlassian/surface-analytics';
import { useProjectPages } from '../../containers/project-pages';

export type ButtonIds = 'learnMoreButton' | 'tryThisTemplateButton';

export const useFireCrossFlowAnalyticsEvents = () => {
	const { fireViewedScreenEvent, fireInteractedUIEvent } = useFireCrossFlowAnalyticsEventsBase();
	const { environment } = useProjectPages();
	const env = environment === 'prod' ? 'prod' : 'staging';
	const confluenceCloudCCPProductID = FIRST_PARTY_CCP_PRODUCT_IDS[env].confluence_cloud;

	return {
		fireViewedEvent: () => {
			fireViewedScreenEvent('projectPagesScreen', {
				recommendedProductIds: [confluenceCloudCCPProductID],
			});
		},

		fireClickedEvent: (buttonId: ButtonIds, attributes: Record<string, unknown> = {}) => {
			fireInteractedUIEvent(
				{
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: buttonId,
				},
				{
					recommendedProductIds: [confluenceCloudCCPProductID],
					targetProductId: confluenceCloudCCPProductID,
					source: 'projectPagesScreen',
				},
				attributes,
			);
		},
	};
};
